import { useMemo } from 'react';

import { NonNullableRewardCategory } from 'pages/loyalty/loyalty-rewards/types';
import { IEngineRewardsMap } from 'state/loyalty/types';

import { Tier } from './use-progress-calculation';

export const useTiers = ({
  engineRewardsMap,
  rewardCategories,
}: {
  engineRewardsMap: IEngineRewardsMap;
  rewardCategories: NonNullableRewardCategory[];
}) => {
  const tiers: Tier[] = useMemo(() => {
    return rewardCategories
      .filter(category => category.rewards?.length && category.label?.en)
      .map(category => {
        const firstValidReward = category.rewards.find(
          reward => reward.loyaltyEngineId && engineRewardsMap[reward.loyaltyEngineId]
        );

        if (!firstValidReward) {
          return null;
        }

        const engineRewardItem = engineRewardsMap[firstValidReward.loyaltyEngineId];

        return {
          points: engineRewardItem.pointCost,
          label: engineRewardItem.pointCost.toString(),
        };
      })
      .filter(Boolean)
      .sort((a, b) => a.points - b.points);
  }, [engineRewardsMap, rewardCategories]);

  return { tiers };
};
